import { useCallback } from "react";

export const useTable = () => {
  const getDataAndColumns = useCallback((payload) => {
    let columns = [];
    let data = [];

    columns = payload?.columns?.map(({ key, title }) => ({
      title,
      dataIndex: key,
      key,
    }));

    payload?.rows?.forEach(({ data: payloadData }, index) => {
      payloadData.forEach(({ key, value }) => {
        data[index] = {
          ...(data[index] || {}),
          [key]: value,
        };
      });
    });

    return { columns, data };
  }, []);

  return { getDataAndColumns };
};
